// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container--38240e3t {\n  font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", \"Consolas\", \"source-code-pro\",\n    monospace;\n}\n\n.title--22JX8c5i {\n  font-size: var(--title-font-size);\n  margin-bottom: var(--card-content-gap);\n}\n\n.ok--scZbOo0Q {\n  color: var(--color-success);\n}\n\n.error--1rhVghP0 {\n  color: var(--color-error);\n}\n\n.warn--2iIOhPHl {\n  color: var(--color-warning);\n}\n\n.item--3EbUDqMV:not(:last-child) {\n  margin-bottom: var(--card-content-gap);\n}\n\n.detail--1SHNesfT {\n  list-style-type: disc;\n}\n\n.summary--iR3yudrT,\n.detail--1SHNesfT > li {\n  padding: 1px 0;\n}\n\n.loading--NObHMOHz,\n.detail--1SHNesfT,\n.link--26EmkDG5 {\n  color: var(--text-color-secondary);\n}\n\n.link--26EmkDG5,\n.link--26EmkDG5:hover {\n  transition: none;\n  text-decoration: none;\n  box-shadow: 0 1px 0 0 currentColor;\n}\n\n.link--26EmkDG5:hover {\n  color: var(--antd-text-color);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "container--38240e3t",
	"title": "title--22JX8c5i",
	"ok": "ok--scZbOo0Q",
	"error": "error--1rhVghP0",
	"warn": "warn--2iIOhPHl",
	"item": "item--3EbUDqMV",
	"detail": "detail--1SHNesfT",
	"summary": "summary--iR3yudrT",
	"loading": "loading--NObHMOHz",
	"link": "link--26EmkDG5"
};
export default ___CSS_LOADER_EXPORT___;
